<syslink-grid
    #gridComponent
    [gridName]="storageKey"
    [canView]="canView"
    [canSearch]="canSearch"
    [canRefresh]="canRefresh"
    [canAdd]="canAdd"
    [canSort]="canSort"
    [canUpdate]="canUpdate"
    [canDelete]="canDelete"
    [canFilter]="canFilter"
    [canExport]="canExport"
    [canDblClck]="canDblClck"
    [store]="customersService.store"
    [archivedStore]="customersService.archivedStore"
    [restoreService]="customersService"
    [columns]="columns"
    [expand]="expand"
    (add)="add.emit()"
    [storageKey]="storageKey"
    (doubleClick)="rowDoubleClicked.emit($event)"
    [select]="select"
></syslink-grid>

